module.exports = __webpack_public_path__ + "static/media/videocallwallpaper.e961f332.png";